
// import React, { useState, useEffect } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   Box,
//   Typography,
//   CircularProgress,
//   Alert,
//   Fade,
//   InputAdornment,
//   Autocomplete,
//   Grid,
//   Card,
//   CardContent,
//   Collapse,
//   FormControlLabel,
//   Checkbox,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Divider,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import {
//   PersonAdd,
//   CheckCircle,
//   Email,
//   VerifiedUser,
//   Male,
//   Female,
//   Wc,
//   Transgender,
//   QuestionMark,
//   Favorite,
//   AllInclusive,
//   PersonOutline,
//   Block,
//   Receipt,
//   CalendarToday,
//   Close,
// } from "@mui/icons-material";
// import axios from "axios";
// import { BASE_URL } from "../../../../services/configUrls";

// const TrainerAddNewFacultyFDP = ({ open, onClose, bookslotId,instituteId, onSuccess }) => {
//   const [step, setStep] = useState(1);
//   const [formData, setFormData] = useState({
//     email: "",
//     edu_name: "",
//     phone_no: "",
//     designation: "",
//     branch: "",
//     gender: "",
//   });
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(false);
//   const [otpTimer, setOtpTimer] = useState(0);
//   const [canResend, setCanResend] = useState(false);
//   const [emailVerified, setEmailVerified] = useState(false);
//   const [showOtherGenders, setShowOtherGenders] = useState(false);
//   const [selectedPrimaryGender, setSelectedPrimaryGender] = useState(null);
//   const [termsAccepted, setTermsAccepted] = useState(false);
//   const [paymentProcessing, setPaymentProcessing] = useState(false);

//   // Gender options with icons
//   const primaryGenderOptions = [
//     { label: "Male", icon: <Male /> },
//     { label: "Female", icon: <Female /> },
//     { label: "Other", icon: <Wc /> },
//   ];

//   const otherGenderOptions = [
//     { label: "Non-Binary", icon: <AllInclusive /> },
//     { label: "Genderqueer", icon: <QuestionMark /> },
//     { label: "Genderfluid", icon: <Favorite /> },
//     { label: "Agender", icon: <Block /> },
//     { label: "Bigender", icon: <Wc /> },
//     { label: "Transgender Man", icon: <Transgender /> },
//     { label: "Transgender Woman", icon: <Transgender /> },
//     { label: "Prefer Not to Say", icon: <PersonOutline /> },
//   ];

//   // Reset form when modal opens/closes
//   useEffect(() => {
//     if (open) {
//       setStep(1);
//       setFormData({
//         email: "",
//         edu_name: "",
//         phone_no: "",
//         designation: "",
//         branch: "",
//         gender: "",
//       });
//       setOtp(["", "", "", "", "", ""]);
//       setError(null);
//       setSuccess(false);
//       setOtpTimer(0);
//       setCanResend(false);
//       setEmailVerified(false);
//       setShowOtherGenders(false);
//       setSelectedPrimaryGender(null);
//       setTermsAccepted(false);
//       setPaymentProcessing(false);
//     }
//   }, [open]);

//   // OTP Timer countdown
//   useEffect(() => {
//     let interval;
//     if (otpTimer > 0) {
//       interval = setInterval(() => {
//         setOtpTimer((prev) => {
//           if (prev <= 1) {
//             setCanResend(true);
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     }
//     return () => clearInterval(interval);
//   }, [otpTimer]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     if (error) setError(null);
//   };

//   const handleGenderChange = (event, newValue) => {
//     if (newValue === "Other") {
//       setShowOtherGenders(true);
//       setSelectedPrimaryGender("Other");
//       setFormData((prev) => ({
//         ...prev,
//         gender: "",
//       }));
//     } else {
//       setShowOtherGenders(false);
//       setSelectedPrimaryGender(newValue);
//       setFormData((prev) => ({
//         ...prev,
//         gender: newValue || "",
//       }));
//     }
//     if (error) setError(null);
//   };

//   const handleOtherGenderSelect = (genderLabel) => {
//     setFormData((prev) => ({
//       ...prev,
//       gender: genderLabel,
//     }));
//     if (error) setError(null);
//   };

//   const handleOtpChange = (index, value) => {
//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value.slice(-1);
//     setOtp(newOtp);

//     // Auto-focus next input
//     if (value && index < 5) {
//       const nextInput = document.getElementById(`otp-${index + 1}`);
//       if (nextInput) nextInput.focus();
//     }

//     if (error) setError(null);
//   };

//   const handleOtpKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       const prevInput = document.getElementById(`otp-${index - 1}`);
//       if (prevInput) prevInput.focus();
//     }
//   };

//   const handleOtpPaste = (e) => {
//     e.preventDefault();
//     const pastedData = e.clipboardData.getData("text").slice(0, 6);
//     if (!/^\d+$/.test(pastedData)) return;

//     const newOtp = [...otp];
//     pastedData.split("").forEach((char, i) => {
//       if (i < 6) newOtp[i] = char;
//     });
//     setOtp(newOtp);

//     // Focus last filled input
//     const lastIndex = Math.min(pastedData.length, 6) - 1;
//     const lastInput = document.getElementById(`otp-${lastIndex}`);
//     if (lastInput) lastInput.focus();
//   };

//   const validateEmail = () => {
//     if (!formData.email.trim()) {
//       setError("Email is required");
//       return false;
//     }
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.email)) {
//       setError("Please enter a valid email address");
//       return false;
//     }
//     return true;
//   };

//   const validateForm = () => {
//     if (!formData.edu_name.trim()) {
//       setError("Educator name is required");
//       return false;
//     }
//     if (!formData.phone_no.trim()) {
//       setError("Phone number is required");
//       return false;
//     }
//     const phoneRegex = /^\d{10,11}$/;
//     if (!phoneRegex.test(formData.phone_no)) {
//       setError("Please enter a valid phone number (10-11 digits)");
//       return false;
//     }
//     if (!formData.designation.trim()) {
//       setError("Designation is required");
//       return false;
//     }
//     if (!formData.branch.trim()) {
//       setError("Branch is required");
//       return false;
//     }
//     if (!formData.gender.trim()) {
//       setError("Gender is required");
//       return false;
//     }
//     return true;
//   };

//   const handleSendOtp = async () => {
//     if (!validateEmail()) {
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       await axios.post(
//         `${BASE_URL}/internship/send-otp/academy-leaders/`,
//         { email: formData.email.trim() },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         },
//       );

//       setStep(2);
//       setOtpTimer(900);
//       setCanResend(false);
//     } catch (err) {
//       console.error("Error sending OTP:", err?.response?.data?.detail);
//       setError(
//         err.response?.data?.detail ||
//           err.response?.data?.error ||
//           "Failed to send OTP. Please try again.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResendOtp = async () => {
//     setLoading(true);
//     setError(null);
//     setOtp(["", "", "", "", "", ""]);

//     try {
//       await axios.post(
//         `${BASE_URL}/internship/send-otp/academy-leaders/`,
//         { email: formData.email.trim() },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         },
//       );

//       setOtpTimer(900);
//       setCanResend(false);
//       setError(null);
//     } catch (err) {
//       console.error("Error resending OTP:", err);
//       setError(
//         err.response?.data?.message ||
//           err.response?.data?.error ||
//           "Failed to resend OTP. Please try again.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const otpValue = otp.join("");
//     if (otpValue.length !== 6) {
//       setError("Please enter complete 6-digit OTP");
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       await axios.post(
//         `${BASE_URL}/internship/verify-otp/academy-leaders/`,
//         {
//           email: formData.email.trim(),
//           otp: otpValue,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         },
//       );

//       setEmailVerified(true);
//       setStep(3);
//       setError(null);
//     } catch (err) {
//       console.error("Error verifying OTP:", err);
//       setError(
//         err.response?.data?.message ||
//           err.response?.data?.error ||
//           "Invalid OTP. Please check and try again.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     setPaymentProcessing(true);
//     setError(null);

//     try {
//       const payload = {
//         edu_name: formData.edu_name.trim(),
//         email: formData.email.trim(),
//         phone_no: formData.phone_no.trim(),
//         designation: formData.designation.trim(),
//         branch: formData.branch.trim(),
//         bookslot_id: bookslotId,
//         gender: formData.gender.trim(),
//       };

//       // Call the new API endpoint
//       const response = await axios.post(
//         `${BASE_URL}/event/add-faculty`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         },
//       );

//       // Set loading to false first, then show success
//       setLoading(false);
//       setPaymentProcessing(false);
//       setError(null);
//       setSuccess(true);

//       if (onSuccess) onSuccess(response.data);

//       // Close modal after 2.5 seconds to show success message
//       setTimeout(() => {
//         onClose();
//       }, 2500);
//     } catch (err) {
//       console.error("Error adding faculty:", err);
//       setLoading(false);
//       setPaymentProcessing(false);
//       setError(
//         err.response?.data?.detail ||
//           err.response?.data?.message ||
//           err.response?.data?.error ||
//           "Failed to add faculty. Please try again.",
//       );
//     }
//   };

//   const handleClose = () => {
//     if (!loading) {
//       onClose();
//     }
//   };

//   const formatTime = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins}:${secs.toString().padStart(2, "0")}`;
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={handleClose}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
//             overflow: "hidden",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//             pb: 2,
//             borderBottom: "1px solid #e0e0e0",
//             background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
//             color: "white",
//           }}
//         >
//           <PersonAdd />
//           <Typography variant="h6" component="span">
//             Add New Faculty
//           </Typography>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             mt: 3,
//             minHeight: step === 1 ? "auto" : showOtherGenders ? 480 : 400,
//             transition: "min-height 0.4s ease-in-out",
//           }}
//         >
//           {error && (
//             <Fade in={!!error}>
//               <Alert
//                 severity="error"
//                 sx={{ mb: 2 }}
//                 onClose={() => setError(null)}
//               >
//                 {error}
//               </Alert>
//             </Fade>
//           )}

//           {success && (
//             <Fade in={success} timeout={500}>
//               <Alert
//                 severity="success"
//                 sx={{
//                   mb: 2,
//                   fontWeight: 600,
//                   fontSize: "1rem",
//                   "& .MuiAlert-icon": {
//                     fontSize: "28px",
//                   },
//                 }}
//                 icon={<CheckCircle />}
//               >
//                 Faculty added successfully!
//               </Alert>
//             </Fade>
//           )}

//           <Box component="form" noValidate>
//             {/* Step 1: Email Entry */}
//             {step === 1 && (
//               <Fade in={step === 1}>
//                 <Box sx={{ py: 2 }}>
//                   <Typography
//                     variant="body2"
//                     color="text.secondary"
//                     sx={{
//                       mb: 2,
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1,
//                     }}
//                   >
//                     <Email fontSize="small" />
//                     Please verify your email address to continue
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     label="Email Address"
//                     name="email"
//                     type="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                     disabled={loading}
//                     placeholder="example@gmail.com"
//                     variant="outlined"
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: 2,
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                           boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
//                         },
//                       },
//                     }}
//                   />
//                 </Box>
//               </Fade>
//             )}

//             {/* Step 2: OTP Verification */}
//             {step === 2 && !success && (
//               <Fade in={step === 2}>
//                 <Box>
//                   <Box
//                     sx={{
//                       textAlign: "center",
//                       mb: 3,
//                       p: 2,
//                       borderRadius: 2,
//                       background:
//                         "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
//                     }}
//                   >
//                     <Email sx={{ fontSize: 40, color: "#1e3a8a", mb: 1 }} />
//                     <Typography variant="body2" color="text.secondary">
//                       We've sent a verification code to
//                     </Typography>
//                     <Typography
//                       variant="body1"
//                       fontWeight={600}
//                       color="#1e3a8a"
//                     >
//                       {formData.email}
//                     </Typography>
//                   </Box>

//                   <Typography
//                     variant="body2"
//                     color="text.secondary"
//                     sx={{ mb: 2, textAlign: "center" }}
//                   >
//                     Enter the 6-digit code
//                   </Typography>

//                   <Box
//                     sx={{
//                       display: "flex",
//                       gap: 1.5,
//                       justifyContent: "center",
//                       mb: 3,
//                     }}
//                   >
//                     {otp.map((digit, index) => (
//                       <TextField
//                         key={index}
//                         id={`otp-${index}`}
//                         value={digit}
//                         onChange={(e) => handleOtpChange(index, e.target.value)}
//                         onKeyDown={(e) => handleOtpKeyDown(index, e)}
//                         onPaste={index === 0 ? handleOtpPaste : undefined}
//                         disabled={loading}
//                         inputProps={{
//                           maxLength: 1,
//                           style: {
//                             textAlign: "center",
//                             fontSize: "24px",
//                             fontWeight: "bold",
//                             color: "#1e3a8a",
//                             padding: 0,
//                           },
//                         }}
//                         sx={{
//                           width: 50,
//                           "& .MuiOutlinedInput-root": {
//                             borderRadius: 2,
//                             height: 60,
//                             transition: "all 0.3s ease",
//                             backgroundColor: digit
//                               ? "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)"
//                               : "#fff",
//                             "&:hover": {
//                               transform: "translateY(-2px)",
//                               boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
//                             },
//                             "&.Mui-focused": {
//                               transform: "scale(1.05)",
//                               boxShadow: "0 4px 16px rgba(59, 130, 246, 0.4)",
//                             },
//                           },
//                           "& .MuiOutlinedInput-notchedOutline": {
//                             borderColor: digit ? "#3b82f6" : "#d1d5db",
//                             borderWidth: digit ? "2px" : "1px",
//                           },
//                           "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
//                             {
//                               borderColor: "#3b82f6",
//                             },
//                           "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                             {
//                               borderColor: "#3b82f6",
//                               borderWidth: "2px",
//                             },
//                           "& input": {
//                             background: digit
//                               ? "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)"
//                               : "transparent",
//                           },
//                         }}
//                       />
//                     ))}
//                   </Box>

//                   {otpTimer > 0 && (
//                     <Fade in={otpTimer > 0}>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: 1,
//                           mb: 2,
//                         }}
//                       >
//                         <Typography variant="body2" color="text.secondary">
//                           Code expires in
//                         </Typography>
//                         <Box
//                           sx={{
//                             background:
//                               "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
//                             color: "white",
//                             px: 2,
//                             py: 0.5,
//                             borderRadius: 2,
//                             fontWeight: "bold",
//                             fontSize: "0.875rem",
//                             minWidth: 60,
//                             textAlign: "center",
//                           }}
//                         >
//                           {formatTime(otpTimer)}
//                         </Box>
//                       </Box>
//                     </Fade>
//                   )}

//                   {canResend && (
//                     <Fade in={canResend}>
//                       <Box sx={{ textAlign: "center" }}>
//                         <Typography
//                           variant="body2"
//                           color="text.secondary"
//                           sx={{ mb: 1 }}
//                         >
//                           Didn't receive the code?
//                         </Typography>
//                         <Button
//                           onClick={handleResendOtp}
//                           disabled={loading}
//                           variant="text"
//                           sx={{
//                             textTransform: "none",
//                             fontWeight: 600,
//                             color: "#3b82f6",
//                             "&:hover": {
//                               backgroundColor: "#dbeafe",
//                             },
//                           }}
//                         >
//                           Resend Code
//                         </Button>
//                       </Box>
//                     </Fade>
//                   )}
//                 </Box>
//               </Fade>
//             )}

//             {/* Step 3: Faculty Details */}
//             {step === 3 && !success && (
//               <Fade in={step === 3}>
//                 <Box>
//                   <TextField
//                     fullWidth
//                     label="Educator Name"
//                     name="edu_name"
//                     value={formData.edu_name}
//                     onChange={handleInputChange}
//                     margin="normal"
//                     required
//                     disabled={loading}
//                     placeholder="Enter educator's full name"
//                     variant="outlined"
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: 2,
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                           boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
//                         },
//                       },
//                     }}
//                   />

//                   <TextField
//                     fullWidth
//                     label="Phone Number"
//                     name="phone_no"
//                     value={formData.phone_no}
//                     onChange={handleInputChange}
//                     margin="normal"
//                     required
//                     disabled={loading}
//                     placeholder="Enter 10-11 digit phone number"
//                     variant="outlined"
//                     inputProps={{
//                       maxLength: 11,
//                       pattern: "[0-9]*",
//                     }}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: 2,
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                           boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
//                         },
//                       },
//                     }}
//                   />

//                   <Autocomplete
//                     options={primaryGenderOptions.map((option) => option.label)}
//                     value={selectedPrimaryGender}
//                     onChange={handleGenderChange}
//                     disabled={loading}
//                     renderOption={(props, option) => {
//                       const genderOption = primaryGenderOptions.find(
//                         (g) => g.label === option,
//                       );
//                       return (
//                         <Box
//                           component="li"
//                           {...props}
//                           sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                         >
//                           {genderOption?.icon}
//                           <Typography>{option}</Typography>
//                         </Box>
//                       );
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Gender"
//                         margin="normal"
//                         required
//                         placeholder="Select gender"
//                         variant="outlined"
//                         InputProps={{
//                           ...params.InputProps,
//                           startAdornment: selectedPrimaryGender && (
//                             <InputAdornment position="start">
//                               {
//                                 primaryGenderOptions.find(
//                                   (g) => g.label === selectedPrimaryGender,
//                                 )?.icon
//                               }
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     )}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: 2,
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                           boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
//                         },
//                       },
//                     }}
//                   />

//                   <Collapse in={showOtherGenders} timeout={600}>
//                     <Box sx={{ mt: 1.5, mb: 1 }}>
//                       <Typography
//                         variant="caption"
//                         color="text.secondary"
//                         sx={{
//                           mb: 1,
//                           display: "block",
//                           fontWeight: 600,
//                           textAlign: "center",
//                         }}
//                       >
//                         Select specific gender identity
//                       </Typography>
//                       <Grid container spacing={0.75}>
//                         {otherGenderOptions.map((option, index) => (
//                           <Grid item xs={4} key={index}>
//                             <Fade
//                               in={showOtherGenders}
//                               timeout={600 + index * 80}
//                             >
//                               <Card
//                                 onClick={() =>
//                                   !loading &&
//                                   handleOtherGenderSelect(option.label)
//                                 }
//                                 sx={{
//                                   cursor: loading ? "not-allowed" : "pointer",
//                                   transition: "all 0.3s ease",
//                                   border:
//                                     formData.gender === option.label
//                                       ? "2px solid #3b82f6"
//                                       : "1px solid #e5e7eb",
//                                   background:
//                                     formData.gender === option.label
//                                       ? "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)"
//                                       : "#fff",
//                                   "&:hover": {
//                                     transform: loading
//                                       ? "none"
//                                       : "translateY(-3px) scale(1.02)",
//                                     boxShadow: loading
//                                       ? "none"
//                                       : "0 6px 16px rgba(59, 130, 246, 0.25)",
//                                     borderColor: "#3b82f6",
//                                   },
//                                 }}
//                               >
//                                 <CardContent
//                                   sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     alignItems: "center",
//                                     gap: 0.5,
//                                     py: 1,
//                                     px: 0.5,
//                                     "&:last-child": { pb: 1 },
//                                   }}
//                                 >
//                                   <Box
//                                     sx={{
//                                       fontSize: 20,
//                                       color:
//                                         formData.gender === option.label
//                                           ? "#1e3a8a"
//                                           : "#6b7280",
//                                       transition: "color 0.3s ease",
//                                     }}
//                                   >
//                                     {option.icon}
//                                   </Box>
//                                   <Typography
//                                     variant="caption"
//                                     sx={{
//                                       textAlign: "center",
//                                       fontWeight:
//                                         formData.gender === option.label
//                                           ? 600
//                                           : 500,
//                                       color:
//                                         formData.gender === option.label
//                                           ? "#1e3a8a"
//                                           : "#374151",
//                                       fontSize: "0.65rem",
//                                       lineHeight: 1.2,
//                                     }}
//                                   >
//                                     {option.label}
//                                   </Typography>
//                                 </CardContent>
//                               </Card>
//                             </Fade>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </Box>
//                   </Collapse>

//                   <TextField
//                     fullWidth
//                     label="Designation"
//                     name="designation"
//                     value={formData.designation}
//                     onChange={handleInputChange}
//                     margin="normal"
//                     required
//                     disabled={loading}
//                     placeholder="e.g., Professor, Assistant Professor"
//                     variant="outlined"
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: 2,
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                           boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
//                         },
//                       },
//                     }}
//                   />

//                   <TextField
//                     fullWidth
//                     label="Branch"
//                     name="branch"
//                     value={formData.branch}
//                     onChange={handleInputChange}
//                     margin="normal"
//                     required
//                     disabled={loading}
//                     placeholder="e.g., CSE, ECE, ME"
//                     variant="outlined"
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: 2,
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                           boxShadow: "0 4px 12px rgba(59, 130, 246, 0.2)",
//                         },
//                       },
//                     }}
//                   />

//                   {/* Terms and Conditions */}
//                   {/* <Box
//                     sx={{
//                       mt: 2,
//                       mb: 1,
//                       p: 2,
//                       borderRadius: 2,
//                       border: "1px solid #e5e7eb",
//                       backgroundColor: "#f9fafb",
//                     }}
//                   >
//                     <Typography
//                       variant="subtitle2"
//                       gutterBottom
//                       sx={{ fontWeight: 600, color: "#1e3a8a" }}
//                     >
//                       Terms and Conditions
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{ mb: 1.5 }}
//                     >
//                       By proceeding with payment, you confirm that all provided
//                       faculty details are accurate and agree to the event
//                       registration and payment policies set by EdSkills
//                       Foundation. Payment is non-refundable once processed.
//                     </Typography>

//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={termsAccepted}
//                           onChange={(e) => setTermsAccepted(e.target.checked)}
//                           disabled={loading}
//                           sx={{
//                             color: "#3b82f6",
//                             "&.Mui-checked": {
//                               color: "#1e3a8a",
//                             },
//                           }}
//                         />
//                       }
//                       label={
//                         <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                           I have read and agree to the terms and conditions
//                         </Typography>
//                       }
//                     />
//                   </Box> */}

//                   <TextField
//                     fullWidth
//                     label="Email Address (Verified)"
//                     name="email"
//                     type="email"
//                     value={formData.email}
//                     margin="normal"
//                     disabled
//                     variant="outlined"
//                     InputLabelProps={{
//                       shrink: true,
//                     }}
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <VerifiedUser
//                             sx={{ color: "#3b82f6", fontSize: 28 }}
//                           />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: 2,
//                         backgroundColor: "#f0f9ff",
//                         paddingRight: 1.5,
//                       },
//                       "& .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#3b82f6",
//                         borderWidth: "2px",
//                       },
//                       "& .MuiInputLabel-root": {
//                         backgroundColor: "#fff",
//                         padding: "0 8px",
//                         color: "#3b82f6",
//                         fontWeight: 600,
//                         "&.Mui-disabled": {
//                           color: "#3b82f6",
//                         },
//                       },
//                     }}
//                   />
//                 </Box>
//               </Fade>
//             )}
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
//           <Button
//             onClick={handleClose}
//             disabled={loading || success}
//             variant="outlined"
//             sx={{
//               borderRadius: 2,
//               textTransform: "none",
//               px: 3,
//               borderColor: "#3b82f6",
//               color: "#3b82f6",
//               "&:hover": {
//                 borderColor: "#1e3a8a",
//                 backgroundColor: "#dbeafe",
//               },
//             }}
//           >
//             {success ? "Close" : "Cancel"}
//           </Button>
//           {!success && (
//             <Button
//               onClick={
//                 step === 1
//                   ? handleSendOtp
//                   : step === 2
//                     ? handleVerifyOtp
//                     : handleSubmit
//               }
//               disabled={loading}
//               variant="contained"
//               startIcon={
//                 loading && <CircularProgress size={20} color="inherit" />
//               }
//               sx={{
//                 borderRadius: 2,
//                 textTransform: "none",
//                 px: 3,
//                 background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
//                 "&:hover": {
//                   background:
//                     "linear-gradient(135deg, #1e40af 0%, #2563eb 100%)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 6px 20px rgba(59, 130, 246, 0.4)",
//                 },
//                 transition: "all 0.3s ease",
//               }}
//             >
//               {loading
//                 ? step === 1
//                   ? "Sending..."
//                   : step === 2
//                     ? "Verifying..."
//                     : paymentProcessing
//                       ? "Processing..."
//                       : "Adding..."
//                 : step === 1
//                   ? "Send OTP"
//                   : step === 2
//                     ? "Verify Email"
//                     : "Add Faculty"}
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default TrainerAddNewFacultyFDP;

import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
  Alert,
  Fade,
  InputAdornment,
  Autocomplete,
  Grid,
  Card,
  CardContent,
  Collapse,
} from "@mui/material";
import {
  PersonAdd,
  CheckCircle,
  Email,
  Male,
  Female,
  Wc,
  Transgender,
  QuestionMark,
  Favorite,
  AllInclusive,
  PersonOutline,
  Block,
} from "@mui/icons-material";
import axios from "axios";
import { BASE_URL } from "../../../../services/configUrls";

const TrainerAddNewFacultyFDP = ({
  open,
  onClose,
  bookslotId,
  instituteId,
  onSuccess,
}) => {
  const [formData, setFormData] = useState({
    email: "",
    edu_name: "",
    phone_no: "",
    designation: "",
    branch: "",
    gender: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [showOtherGenders, setShowOtherGenders] = useState(false);
  const [selectedPrimaryGender, setSelectedPrimaryGender] = useState(null);

  // Gender options
  const primaryGenderOptions = [
    { label: "Male", icon: <Male /> },
    { label: "Female", icon: <Female /> },
    { label: "Other", icon: <Wc /> },
  ];

  const otherGenderOptions = [
    { label: "Non-Binary", icon: <AllInclusive /> },
    { label: "Genderqueer", icon: <QuestionMark /> },
    { label: "Genderfluid", icon: <Favorite /> },
    { label: "Agender", icon: <Block /> },
    { label: "Bigender", icon: <Wc /> },
    { label: "Transgender Man", icon: <Transgender /> },
    { label: "Transgender Woman", icon: <Transgender /> },
    { label: "Prefer Not to Say", icon: <PersonOutline /> },
  ];

  // Reset on open
  useEffect(() => {
    if (open) {
      setFormData({
        email: "",
        edu_name: "",
        phone_no: "",
        designation: "",
        branch: "",
        gender: "",
      });
      setError(null);
      setSuccess(false);
      setShowOtherGenders(false);
      setSelectedPrimaryGender(null);
    }
  }, [open]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError(null);
  };

  const handleGenderChange = (event, newValue) => {
    if (newValue === "Other") {
      setShowOtherGenders(true);
      setSelectedPrimaryGender("Other");
      setFormData((prev) => ({ ...prev, gender: "" }));
    } else {
      setShowOtherGenders(false);
      setSelectedPrimaryGender(newValue);
      setFormData((prev) => ({ ...prev, gender: newValue || "" }));
    }
  };

  const handleOtherGenderSelect = (label) => {
    setFormData((prev) => ({ ...prev, gender: label }));
  };

  const validateEmail = () => {
    if (!formData.email.trim()) {
      setError("Email is required");
      return false;
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(formData.email)) {
      setError("Invalid email address");
      return false;
    }
    return true;
  };

  const validateForm = () => {
    if (!formData.edu_name.trim()) return setError("Educator name required");
    if (!formData.phone_no.trim()) return setError("Phone number required");
    if (!/^\d{10,11}$/.test(formData.phone_no))
      return setError("Phone must be 10–11 digits");
    if (!formData.designation.trim())
      return setError("Designation required");
    if (!formData.branch.trim()) return setError("Branch required");
    if (!formData.gender.trim()) return setError("Gender required");
    return true;
  };

  const handleSubmit = async () => {
    if (!validateEmail() || !validateForm()) return;

    setLoading(true);
    setError(null);

    try {
      const payload = {
        edu_name: formData.edu_name.trim(),
        email: formData.email.trim(),
        phone_no: formData.phone_no.trim(),
        designation: formData.designation.trim(),
        branch: formData.branch.trim(),
        gender: formData.gender.trim(),
        bookslot_id: bookslotId,
        institute_id: instituteId,
      };

      const res = await axios.post(
        `${BASE_URL}/event/trainer-add-faculty`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      setSuccess(true);
      if (onSuccess) onSuccess(res.data);

      setTimeout(onClose, 2000);
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to add faculty"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", gap: 1 }}>
        <PersonAdd /> Add New Faculty
      </DialogTitle>

      <DialogContent>
        {error && (
          <Fade in>
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          </Fade>
        )}

        {success && (
          <Fade in>
            <Alert severity="success" icon={<CheckCircle />}>
              Faculty added successfully!
            </Alert>
          </Fade>
        )}

        <TextField
          fullWidth
          label="Email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          margin="normal"
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Email />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          label="Educator Name"
          name="edu_name"
          value={formData.edu_name}
          onChange={handleInputChange}
          margin="normal"
          required
        />

        <TextField
          fullWidth
          label="Phone Number"
          name="phone_no"
          value={formData.phone_no}
          onChange={handleInputChange}
          margin="normal"
          required
          inputProps={{ maxLength: 11 }}
        />

        <Autocomplete
          options={primaryGenderOptions.map((g) => g.label)}
          value={selectedPrimaryGender}
          onChange={handleGenderChange}
          renderInput={(params) => (
            <TextField {...params} label="Gender" margin="normal" required />
          )}
        />

        <Collapse in={showOtherGenders}>
          <Grid container spacing={1} sx={{ mt: 1 }}>
            {otherGenderOptions.map((opt) => (
              <Grid item xs={4} key={opt.label}>
                <Card
                  onClick={() => handleOtherGenderSelect(opt.label)}
                  sx={{
                    cursor: "pointer",
                    border:
                      formData.gender === opt.label
                        ? "2px solid #3b82f6"
                        : "1px solid #e5e7eb",
                  }}
                >
                  <CardContent sx={{ textAlign: "center", py: 1 }}>
                    {opt.icon}
                    <Typography variant="caption">{opt.label}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Collapse>

        <TextField
          fullWidth
          label="Designation"
          name="designation"
          value={formData.designation}
          onChange={handleInputChange}
          margin="normal"
          required
        />

        <TextField
          fullWidth
          label="Branch"
          name="branch"
          value={formData.branch}
          onChange={handleInputChange}
          margin="normal"
          required
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          startIcon={loading && <CircularProgress size={18} />}
        >
          {loading ? "Adding..." : "Add Faculty"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrainerAddNewFacultyFDP;
